import { Navigate } from 'react-router-dom';

import { useAuth } from '../contexts/AuthContext';
import { hasViewPermission } from '../auth/permissions';
import Loader from '../ui-component/Loader';

const PermissionRoute = ({ permission, children }) => {
    const { authorizationLoaded, privileges } = useAuth();

    if (!permission) {
        return children;
    }

    if (!authorizationLoaded) {
        return <Loader />;
    }

    return hasViewPermission(privileges, permission) ? children : <Navigate to="/dashboard/default" replace />;
};

export default PermissionRoute;
